import { type ReactNode, type FC } from "react";
import styles from "./Chip.module.css";

interface Props {
  children?: ReactNode;
  className?: string;
  variant?:
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning"
    | "light";
  size?: "small" | "medium";
}

const Chip: FC<Props> = ({
  className,
  children,
  variant = "primary",
  size = "normal",
}) => {
  return (
    <div
      role={"chip"}
      className={`${styles.container} ${styles[variant]} ${
        size === "small" ? styles.small : styles.normal
      } ${className}`}
    >
      {children}
    </div>
  );
};

export default Chip;
